import { UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/components/ui/table';
import { mockUsers, mockGroups, INSTITUTION_CONFIG } from './mockData';

const UserManagementTab = () => {
  const groupMap = Object.fromEntries(mockGroups.map((g) => [g.id, g.name]));

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          {mockUsers.length} von {INSTITUTION_CONFIG.maxUsers} Plätzen belegt
        </p>
        <Button size="sm" className="gap-2">
          <UserPlus className="h-4 w-4" />
          Nutzer einladen
          <span className="ml-1 rounded-full bg-primary-foreground/20 px-2 py-0.5 text-xs">
            {INSTITUTION_CONFIG.maxUsers - mockUsers.length} frei
          </span>
        </Button>
      </div>

      <div className="rounded-xl border border-border/50 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Gruppe</TableHead>
              <TableHead className="text-right">Paper</TableHead>
              <TableHead className="text-right">Versionen</TableHead>
              <TableHead className="text-right">Reviews</TableHead>
              <TableHead className="text-right">Letzte Aktivität</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockUsers.map((u) => (
              <TableRow key={u.id}>
                <TableCell>
                  <div>
                    <p className="font-medium">{u.name}</p>
                    <p className="text-xs text-muted-foreground">{u.email}</p>
                  </div>
                </TableCell>
                <TableCell>
                  {u.groupId ? (
                    <span className="inline-flex items-center rounded-full bg-secondary px-2.5 py-0.5 text-xs font-medium">
                      {groupMap[u.groupId] ?? '—'}
                    </span>
                  ) : (
                    <span className="text-muted-foreground text-xs">—</span>
                  )}
                </TableCell>
                <TableCell className="text-right">{u.papersCount}</TableCell>
                <TableCell className="text-right">{u.versionsCount}</TableCell>
                <TableCell className="text-right">{u.reviewsUsed}</TableCell>
                <TableCell className="text-right text-sm text-muted-foreground">
                  {new Date(u.lastActive).toLocaleDateString('de-DE')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default UserManagementTab;
